module.exports = __webpack_public_path__ + "img/white-bg.e8fc6687.jpg";